import { FC, useMemo, useState } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { ProductCatalogProvider } from "./ProductCatalogContext";
import { useProductCatalogDownload } from "./hooks/useProductCatalogDownload";

export const ProductCatalog: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedTab = useMemo(() => {
    if (
      location.pathname.includes("catalog/product/category") ||
      location.pathname.includes("catalog/product/attribute")
    ) {
      return 1;
    }

    // Default is search tab
    return 0;
  }, [location]);

  const { callback, loading } = useProductCatalogDownload();

  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadCatalog = () => {
    if (isDownloading) return;
    setIsDownloading(true);
    setTimeout(() => {
      callback();
      setIsDownloading(false);
    }, 380);
  };

  return (
    <Stack sx={{ overflowX: "auto" }}>
      <Box p="30px">
        <Box mb={3}>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontSize: "32px",
              fontWeight: 600,
              lineHeight: 1,
              marginBottom: "8px",
              color: "#1f1f1f",
            }}
          >
            Tech & Taxonomies
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "16px",
              color: "#6b7280",
              lineHeight: 1.5,
            }}
          >
            Explore technology categories and taxonomies for market analysis.
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Tabs value={selectedTab}>
            <Tab
              label="SEARCH CATALOG"
              id="product-catalog-tab-search"
              onClick={() => {
                navigate(`/catalog/product/search`);
              }}
            />
            <Tab
              label="BROWSE"
              id="product-catalog-tab-browse"
              onClick={() => {
                navigate(`/catalog/product/category`);
              }}
            />
          </Tabs>
          <Box width={190}>
            <Button
              id="product-catalog-download"
              fullWidth
              variant="contained"
              onClick={handleDownloadCatalog}
              disabled={isDownloading || loading}
            >
              {isDownloading ? "Downloading..." : "Download Catalog"}
            </Button>
          </Box>
        </Box>
      </Box>

      <Box sx={{ overflowX: "auto" }} height="100vh" px="30px" pb={2}>
        <ProductCatalogProvider>
          <Outlet />
        </ProductCatalogProvider>
      </Box>
    </Stack>
  );
};
